export default "__VITE_ASSET__DY_Cf7ZU__"